import { Injectable } from "@angular/core";
import { EditDialogService } from '../../../core/components/editDialog/editDialogService';
import { CommandInput, CommandTemplate } from '../../../core/entities/commandTemplate/commandTemplate';
import { CommandService, Flow, HasCommands, Reloadable } from '../../../core/services/command/command.service';
import { TaskViewComponent } from "src/app/rent-module/containers/task-view/task-view.component";
import { TaskInput } from "src/app/rent-module/shared/entities/taskInput/taskInput";

@Injectable({
  providedIn: 'root'
})
export class TaskUpdateCommandCustomFlow implements Flow {
  async executeFlow(commandService: CommandService, hasCommands: HasCommands,
    commandTemplate: CommandTemplate, commandInput: CommandInput,
    completionCallback: () => void, reloadable?: Reloadable): Promise<any> {

      console.log(commandTemplate);
    if (reloadable instanceof TaskViewComponent) {
      try {
        // Enter edit mode and wait for result
        const result = await reloadable.enterEditMode();

        if (result.action === 'save') {
          const taskInput = new TaskInput();
          taskInput.id = hasCommands.getEntityId();
          taskInput.title = result.data.title;
          taskInput.description = result.data.description;
          commandInput.addParameter("taskInput", taskInput);
          commandInput.addParameter("commandProviderId", hasCommands.getEntityId());
          
          commandService.sendCommand(commandInput, () => {
            completionCallback();
          })
        }
        completionCallback();
      } catch (error) {
        completionCallback();
      }
    }
  }
}